import { computed } from "vue";
import { apexChartTypes } from "@/src/constants/analyticConstants.js";
import { formatLocaleNumber } from "@/src/utils/analyticsChartUtils.js";

export const usePieDonutChartOptions = ({
  baseOptions,
  textColor,
  labels,
  getPieFormattedValue,
  apexType,
  decimalPlaces,
}) => {
  return computed(() => ({
    ...baseOptions.value,
    labels: labels.value,
    stroke: {
      width: 2,
      colors: ["transparent"],
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        const dp = decimalPlaces?.value !== undefined && decimalPlaces?.value !== null ? decimalPlaces.value : 1;
        return `${val.toFixed(dp)}%`;
      },
      style: {
        fontSize: "11px",
        fontFamily: "Proxima Nova, sans-serif",
        fontWeight: 600,
        colors: Array(Math.max(labels.value.length, 1)).fill("#FFFFFF"),
      },
      dropShadow: { enabled: false },
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        startAngle: 0,
        endAngle: 360,
        donut: {
          size: apexType.value === apexChartTypes.DONUT ? "60%" : "0%",
          labels: {
            show: apexType.value === apexChartTypes.DONUT,
            name: {
              show: true,
              fontSize: "13px",
              fontFamily: "Proxima Nova, sans-serif",
              color: textColor,
              offsetY: -8,
            },
            value: {
              show: true,
              fontSize: "18px",
              fontFamily: "Proxima Nova, sans-serif",
              fontWeight: 600,
              color: textColor,
              offsetY: 4,
              formatter: (val, opts) => {
                if (opts && opts.seriesIndex !== undefined) {
                  return getPieFormattedValue(opts.seriesIndex);
                }
                return val;
              },
            },
            total: {
              show: true,
              label: "Total",
              fontSize: "11px",
              fontFamily: "Proxima Nova, sans-serif",
              color: textColor,
              formatter: (w) => {
                const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                return formatLocaleNumber(total, { decimalPlaces: decimalPlaces?.value });
              },
            },
          },
        },
      },
    },
    tooltip: {
      ...baseOptions.value.tooltip,
      y: {
        formatter: (val, opts) => getPieFormattedValue(opts.seriesIndex),
      },
    },
  }));
};
